import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiHeaders } from './headers';
import { AuthRestResponse, RestResponse } from '../model/io/api';
import { environment } from 'src/environments/environment';
import { AuthenticationRequest } from '../model/auth';

@Injectable()
export class AuthProvider {

  constructor(
    private http: HttpClient
  ) { }

  authenticate(params: AuthenticationRequest): Observable<AuthRestResponse> {
    return this.http.post<AuthRestResponse>(`${environment.API_URL}/api/auth`, params, ApiHeaders.getOptions());
  }

  getUserByCode(code: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(`/api/auth/code/${code}`, ApiHeaders.getOptions());
  }

  getRecoveryByCode(code: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(`/api/auth/reset/${code}`, ApiHeaders.getOptions());
  }

  register(params, code: string): Observable<AuthRestResponse> {
    return this.http.post<AuthRestResponse>(`/api/auth/register?code=${code}`, params, ApiHeaders.getOptions());
  }

  signUp(params): Observable<AuthRestResponse> {
    return this.http.post<AuthRestResponse>(`/api/auth/signup`, params, ApiHeaders.getOptions());
  }

  resetUserByEmail(email: string): Observable<AuthRestResponse> {
    return this.http.post<AuthRestResponse>(`/api/auth/reset?email=` + encodeURIComponent(email), null, ApiHeaders.getOptions());
  }

  completeReset(params, code: string): Observable<RestResponse> {
    return this.http.post<RestResponse>(`/api/auth/reset/${code}`, params, ApiHeaders.getOptions());
  }

  authVerify(email: string, password: string, code: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>('/api/auth/verify', {
        email: email,
        password: password,
        code: code
      }, ApiHeaders.getOptions());
  }

  checkBrokerPromo(promo: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(`/api/pub/promo?code=${promo}`, ApiHeaders.getOptions());
  }


}
